import { IPaths } from 'Shared/Core/ApiPath/IPaths';

export const AtashsooziOmumiPaths: IPaths = {
  BimehNameh: {
    EstelamAndSodoor: '/Atashsoozi/Omumi/EstelamAndSodoor',
    Estelam: '/Atashsoozi/Omumi/Estelam',
    List: '/Atashsoozi/Omumi/List',
    Detail: '/Atashsoozi/Omumi/Detail',
    Sodoor: '/Atashsoozi/Omumi/Sodoor',
    ElhaghiyehSaderehDetail: '/Atashsoozi/Omumi/ElhaghiyehSaderehDetail',
    ElhaghiyehHayeSadereh: '/Atashsoozi/Omumi/ElhaghiyehHayeSadereh',
  },
};
